module.exports = __webpack_public_path__ + "static/media/OutliersQ4_1.acbfed8a.svg";